"use client";

import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { Section } from "./Section";
import p1 from "@/assets/parent-1.jpg";
import p2 from "@/assets/parent-2.jpg";
import p3 from "@/assets/parent-3.jpg";
import Image from "next/image";

const testimonials = [
  {
    name: "Aisha Bennett",
    role: "Parent of Maya, Grade 9",
    img: p1,
    quote:
      "Atherton didn't just educate my daughter — they taught her how to think, how to lead, and how to listen. It's been transformational.",
  },
  {
    name: "Daniel Park",
    role: "Parent of Eli, Grade 11",
    img: p2,
    quote:
      "The teachers know my son. Really know him. That kind of attention is something we'd given up hoping to find.",
  },
  {
    name: "Sofia Ramirez",
    role: "Parent of Lucia, Grade 7",
    img: p3,
    quote:
      "From day one, Lucia has come home excited. The arts program alone is worth every cent of tuition.",
  },
  {
    name: "Aisha Bennett",
    role: "Parent of Maya, Grade 9",
    img: p1,
    quote:
      "Atherton didn't just educate my daughter — they taught her how to think, how to lead, and how to listen.",
  },
  {
    name: "Daniel Park",
    role: "Parent of Eli, Grade 11",
    img: p2,
    quote:
      "The teachers know my son. Really know him. That kind of attention is rare.",
  },
];

export function Testimonials() {
  return (
    <Section id="testimonials" className="bg-navy-grain text-primary-foreground overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="mx-auto max-w-3xl text-center">
          <p className="font-display text-[11px] font-bold uppercase tracking-[0.25em] text-gold">
            Family Voices
          </p>
          <h2 className="mt-3 text-balance text-4xl font-extrabold md:text-5xl">
            Trusted by{" "}
            <span className="font-serif-body italic font-medium text-gold">
              parents who refuse to compromise.
            </span>
          </h2>
        </div>
      </div>

      <div className="mt-14 [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
        <motion.div
          className="flex gap-6 w-max"
          animate={{ x: ["0%", "-50%"] }}
          transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
        >
          {[...testimonials, ...testimonials].map((t, i) => (
            <article
              key={i}
              className="w-[360px] shrink-0 rounded-3xl border border-white/10 bg-white/[0.04] p-7 backdrop-blur md:w-[420px]"
            >
              <Quote className="h-7 w-7 text-gold" />
              <p className="mt-5 font-serif-body text-lg leading-relaxed text-white/90">
                "{t.quote}"
              </p>
              <div className="mt-6 flex items-center gap-4 border-t border-white/10 pt-5">
                <Image
                  src={t.img}
                  alt={t.name}
                  loading="lazy"
                  className="h-12 w-12 rounded-full object-cover"
                />
                <div className="flex-1">
                  <p className="font-display text-sm font-bold">{t.name}</p>
                  <p className="text-xs text-white/60">{t.role}</p>
                </div>
                <div className="flex gap-0.5 text-gold">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <Star key={j} className="h-3.5 w-3.5 fill-current" />
                  ))}
                </div>
              </div>
            </article>
          ))}
        </motion.div>
      </div>
    </Section>
  );
}
